import { render, staticRenderFns } from "./SearchUsers.vue?vue&type=template&id=5660763f&scoped=true&"
import script from "./searchUsers.ts?vue&type=script&lang=ts&"
export * from "./searchUsers.ts?vue&type=script&lang=ts&"
import style0 from "./SearchUsers.vue?vue&type=style&index=0&id=5660763f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5660763f",
  null
  
)

export default component.exports